export default {
  maxUserAvatarSize: 2 * 1024 * 1024, // 2MB (in bytes)
}
